import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { ReportPath } from './routes';

const SalesByPeriod = lazy(() => import('./pages/SalesByPeriod/SalesByPeriod'));
const ProductExpiration = lazy(() => import('./pages/ProductExperiration/ProductExperiration'));
const TopSellingProducts = lazy(() => import('./pages/TopSellingProducts/TopSellingProducts'));
const StockReplenishment = lazy(() => import('./pages/StockReplenishment/StockReplenishment'));
const AccountsReceivable = lazy(() => import('./pages/AccountsReceivable/AccountsReceivable'));

export const ReportRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={ReportPath.SalesPeriod} element={<SalesByPeriod />} />
        <Route path={ReportPath.ProductExpiration} element={<ProductExpiration />} />
        <Route path={ReportPath.TopSellingProducts} element={<TopSellingProducts />} />
        <Route path={ReportPath.StockReplenishment} element={<StockReplenishment />} />
        <Route path={ReportPath.AccountsReceivable} element={<AccountsReceivable />} />
        <Route path="*" element={<Redirect to={ReportPath.SalesPeriod} replace />} />
      </Routes>
    </Suspense>
  );
};

export const ReportRouter: React.FC = () => <ReportRoutes />;
